import { createNode } from '@glueapp/graph-types';

export const ListOfWordsFromText = createNode({
    id: 'List of Words from Text',
    name: 'List of Words from Text',
    description:
        'Splits the Text into a list of the words in the text. Example: "A lovely walk in the park" becomes a list of "A", "lovely", "walk", "in", "the", "park".',
    aiDescription: 'Splits a string into an array of words by whitespace. Connect a string to "Text"; outputs a string array on "Words".',
    category: 'Text',
    color: '#387cc8',
    integration: undefined,
    inPorts: {
        Text: {
            kind: 'string',
        },
    },
    outPorts: {
        Words: {
            kind: 'array',
            subType: {
                kind: 'string',
            },
        },
    },
    execute: function (input) {
        return { output: { Words: (input.inPorts.Text as string).split(/\s/).filter(word => word.length) } };
    },
});
